import EmailIcon from 'assets/img/icons/email.svg?react';
import i18n from 'infrastructure/i18n';

import s from './styles.module.scss';

import type { FC } from 'react';

const successTextMap = {
  text: {
    en: i18n.t('smsCampaign.sendFormMessageEng'),
    es: i18n.t('smsCampaign.sendFormMessageEsp'),
  },
  desc: {
    en: i18n.t('smsCampaign.sendFormDescriptionEng'),
    es: i18n.t('smsCampaign.sendFormDescriptionEsp'),
  },
} as const;

interface SuccessMessageProps {
  lang: 'en' | 'es';
}

const SuccessMessage: FC<SuccessMessageProps> = ({ lang }) => {
  return (
    <div className={s.wrapper}>
      <EmailIcon className={s.icon} />
      <p className={s.text}>{successTextMap.text[lang]}</p>
      <p className={s.desc}>{successTextMap.desc[lang]}</p>
    </div>
  );
};
export default SuccessMessage;
